export default [
  {
    path: '/app/references_types',
    name: 'ReferencesTypes',
    component: () => import('@/views/Admin/ReferencesTypes/Index.vue'),
    meta: {
      pageTitle: 'Referans Tipleri',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_REFERENCES_TYPES',
      action: 'read',
    },
  },
  {
    path: '/app/references_types/add',
    name: 'ReferencesTypesAdd',
    component: () => import('@/views/Admin/ReferencesTypes/Add.vue'),
    meta: {
      pageTitle: 'Referans Tipleri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/references_types',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_REFERENCES_TYPES',
      action: 'read',
    },
  },
  {
    path: '/app/references_types/edit/:id',
    name: 'ReferencesTypesEdit',
    component: () => import('@/views/Admin/ReferencesTypes/Edit.vue'),
    meta: {
      pageTitle: 'Referans Tipleri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/references_types',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_REFERENCES_TYPES',
      action: 'read',
    },
  },
]
